import React, { useState } from "react";

function ChangeList({ items, variant }) {
	if (!items.length) return null;
	return (
		<ul className={`schema-optimizer__change-list schema-optimizer__change-list--${variant}`}>
			{items.map((item) => (
				<li key={item} className="schema-optimizer__change-list-item">
					<span className="schema-optimizer__change-list-bullet" aria-hidden />
					<span>{item}</span>
				</li>
			))}
		</ul>
	);
}

export default function SchemaOptimizerWhatChanged({ changes }) {
	const [omittedOpen, setOmittedOpen] = useState(false);

	if (!changes) return null;

	const { added = [], fixed = [], couldNotInfer = [] } = changes;
	const hasContent =
		added.length > 0 || fixed.length > 0 || couldNotInfer.length > 0;
	if (!hasContent) return null;

	return (
		<section className="schema-optimizer__what-changed mt-4">
			<div className="schema-optimizer__what-changed-head">
				<h3 className="schema-optimizer__what-changed-title mb-0">What changed</h3>
				<div className="schema-optimizer__what-changed-stats">
					<span className="schema-optimizer__change-stat schema-optimizer__change-stat--added">
						{added.length} added
					</span>
					<span className="schema-optimizer__change-stat schema-optimizer__change-stat--fixed">
						{fixed.length} fixed
					</span>
					<span className="schema-optimizer__change-stat schema-optimizer__change-stat--omitted">
						{couldNotInfer.length} omitted
					</span>
				</div>
			</div>

			<div className="schema-optimizer__what-changed-grid">
				{added.length > 0 && (
					<div className="schema-optimizer__what-changed-panel schema-optimizer__what-changed-panel--added">
						<h4 className="schema-optimizer__what-changed-heading">
							<i className="fas fa-plus schema-optimizer__what-changed-icon" aria-hidden />
							Added from page
						</h4>
						<ChangeList items={added} variant="added" />
					</div>
				)}
				{fixed.length > 0 && (
					<div className="schema-optimizer__what-changed-panel schema-optimizer__what-changed-panel--fixed">
						<h4 className="schema-optimizer__what-changed-heading">
							<i className="fas fa-wrench schema-optimizer__what-changed-icon" aria-hidden />
							Fixed in existing markup
						</h4>
						<ChangeList items={fixed} variant="fixed" />
					</div>
				)}
			</div>

			{couldNotInfer.length > 0 && (
				<div className="schema-optimizer__what-changed-omitted">
					<button
						type="button"
						className="schema-optimizer__what-changed-omitted-toggle"
						onClick={() => setOmittedOpen((open) => !open)}
						aria-expanded={omittedOpen}
					>
						<i className="fas fa-minus-circle me-2" aria-hidden />
						Not on page ({couldNotInfer.length})
						<i
							className={`fas fa-chevron-${omittedOpen ? "up" : "down"} ms-2 schema-optimizer__what-changed-chevron`}
							aria-hidden
						/>
					</button>
					{omittedOpen && (
						<div className="schema-optimizer__what-changed-omitted-body">
							<div className="schema-optimizer__omitted-chips">
								{couldNotInfer.map((item) => (
									<span key={item} className="schema-optimizer__omitted-chip">
										{item}
									</span>
								))}
							</div>
						</div>
					)}
				</div>
			)}
		</section>
	);
}
